import { CSSProperties } from "react";
import { StartOutlineIcon } from "./Icons";

interface Props {
  rating: number;
  size?: "md" | "sm";

  className?: string;
  style?: CSSProperties;
}

const RatingStars = ({
  rating,
  size = "md",

  className,
  style,
}: Props) => {
  const iconSize = size === "sm" ? 14 : 16;

  return (
    <div className={className} style={style}>
      <div className="flex gap-2 items-center text-[0.75rem] md:text-[0.83rem] font-semibold">
        {[1, 2, 3, 4, 5].map((i) => {
          const fill = rating >= i;

          if (rating < i && rating > i - 1)
            return (
              <div className="relative" key={'star'+i}>
                <StartOutlineIcon
                    key={'star-'+i}
                  width={iconSize}
                  height={iconSize}
                  className="[&>*]:stroke-secondary-yellow w-[0.7rem] h-[0.7rem] sm:w-auto sm:h-auto"
                />

                <span
                  className="absolute top-0 left-0 z-10"
                  style={{
                    clipPath:
                      "inset(0 " + (1 - (rating - (i - 1))) * 100 + "% 0 0)",
                  }}
                >
                  <StartOutlineIcon
                    key={'star-fill-'+i}
                    width={iconSize}
                    height={iconSize}
                    className="[&>*]:stroke-secondary-yellow fill-secondary-yellow w-[0.7rem] h-[0.7rem] sm:w-auto sm:h-auto"
                  />
                </span>
              </div>
            );

          return (
            <StartOutlineIcon
              key={'star-'+i}
              width={iconSize}
              height={iconSize}
              className={
                "[&>*]:stroke-secondary-yellow w-[0.7rem] h-[0.7rem] sm:w-auto sm:h-auto" +
                " " +
                (fill ? "fill-secondary-yellow" : "")
              }
            />
          );
        })}
        ({rating.toFixed(1)})
      </div>
    </div>
  );
};

export const RatingStarsOnlyStars = ({
  rating,
  sizePX = 16,
}: Props & {
  sizePX?: number;
}) => {
  const iconSize = sizePX;

  return (
    <div className="flex gap-2 items-center text-[0.83rem] font-semibold">
      {[1, 2, 3, 4, 5].map((i) => {
        const fill = rating >= i;

        if (rating < i && rating > i - 1)
          return (
            <div key={'star'+i} className="relative">
              <StartOutlineIcon
                key={'star-'+i}
                width={iconSize}
                height={iconSize}
                className="[&>*]:stroke-secondary-yellow"
              />

              <span
                className="absolute top-0 left-0 z-10"
                style={{
                  clipPath:
                    "inset(0 " + (1 - (rating - (i - 1))) * 100 + "% 0 0)",
                }}
              >
                <StartOutlineIcon
                  key={'star-fill-'+i}
                  width={iconSize}
                  height={iconSize}
                  className="[&>*]:stroke-secondary-yellow fill-secondary-yellow"
                />
              </span>
            </div>
          );

        return (
          <StartOutlineIcon
            key={'star-'+i}
            width={iconSize}
            height={iconSize}
            className={
              "[&>*]:stroke-secondary-yellow" +
              " " +
              (fill ? "fill-secondary-yellow" : "")
            }
          />
        );
      })}
    </div>
  );
};

export default RatingStars;
